import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dark-swtich-btn" }
const _hoisted_2 = ["aria-label", "title"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-moon" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "switch-toggle transition d-inline-block position-relative border-0 rounded-circle",
      id: "switch-toggle",
      "aria-label": _ctx.isDarkMode ? 'Ativar tema claro' : 'Ativar tema escuro',
      title: _ctx.isDarkMode ? 'Ativar tema claro' : 'Ativar tema escuro',
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDarkMode && _ctx.toggleDarkMode(...args)))
    }, _hoisted_4, 8, _hoisted_2)
  ]))
}